import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

// Contract:
// Inputs
//  - search: boolean flag to show search icon (left) and omit label text
//  - datePicker: boolean flag to show date picker button (right side)
//  - label: text for the label (shown only when neither search nor datePicker is active per spec clarification: label hidden if search true; allowed if datePicker true but search false?)
//    User request: "si el flag para search esta como true, no se agregara el label" => label suppressed only when search true.
//  - placeholder: optional placeholder for the input element
//  - disabled: apply disabled state + grey-200 bg
// Output
//  - valueChange: emit string value as user types
// Assumptions: datePicker behavior not implemented (no calendar popup) – placeholder button icon for future enhancement.
// Using material symbol text rendering relying on global font (user previously used keyboard_arrow_up). We'll follow same approach: <span class="material-symbols-outlined">search</span>
// If both flags false, label displayed above input per second pasted image.

@Component({
  selector: 'app-az-searchbar',
  imports: [],
  templateUrl: './az-searchbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './az-searchbar.component.scss',
})
export class AzSearchbarComponent {
  @Input() search = false;
  @Input() datePicker = false;
  @Input() label: string | null = null;
  @Input() placeholder: string | null = null;
  @Input() disabled = false;

  @Input() value: string = '';
  @Output() valueChange = new EventEmitter<string>();

  onInput(ev: Event) {
    const target = ev.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(this.value);
  }
}
